import { Dispatch, Store } from 'redux';
import { push } from 'react-router-redux';
import Event from '../Event';
import { History } from 'history';
import LocationDescriptor = History.LocationDescriptor;

export interface EventToNavigation {
    type: string | ((event: Event) => boolean);
    path: (event: Event, store: Store) => LocationDescriptor;
}

// tslint:disable:typedef
export default (configuration: EventToNavigation[]) => (store: Store) => (next: Dispatch<Event>) => (event: Event): Event => {
    const existingMap: EventToNavigation | undefined = configuration.find(
        (map: EventToNavigation): boolean => {
            return typeof map.type === 'string' ? map.type === event.type : map.type(event);
        }
    );
    if (existingMap) {
        setTimeout(() => {
            next(push(existingMap.path(event, store)));
        }, 1);
    }
    return next(event);
};



// WEBPACK FOOTER //
// ./src/application/core/middleware/eventToNavigation.ts